/**
 * The Copilot section's status (docs/superpowers/specs/2026-10-13-copilot-chat-design.md §4), from
 * Tenant.CopilotConsentState: true = the last observed Graph token carried all seven Copilot scopes,
 * false = it lacked one, null = never observed.
 *
 * The API serialises with NullValueHandling.Ignore, so "never observed" normally arrives as an ABSENT
 * member (undefined), not null. Both read as "unknown" ("Not checked yet"), never as "missing": a
 * tenant nobody has signed in to since the deploy has not refused anything.
 */
export type CopilotConsentStatus = "granted" | "missing" | "unknown";

export function getCopilotConsentStatus(state: boolean | null | undefined): CopilotConsentStatus {
    if (state === true) {
        return "granted";
    }
    if (state === false) {
        return "missing";
    }
    return "unknown";
}

/**
 * Tenant.CopilotConsentCheckedAt is written in UTC, but SQL datetime2 carries no offset, so the API
 * sends it without one ("2026-10-13T08:00:00"), which Date would read as LOCAL time. A value without
 * an offset is therefore read as UTC. More than three fractional digits (datetime2 keeps seven) are
 * cut to milliseconds, which every browser parses. Null for a missing or unreadable value.
 */
export function parseCopilotCheckedAt(value: string | null | undefined): Date | null {
    if (!value) {
        return null;
    }
    const trimmed = value.trim().replace(/(\.\d{3})\d+/, "$1");
    const hasOffset = /(Z|[+-]\d{2}:?\d{2})$/i.test(trimmed);
    const parsed = new Date(hasOffset ? trimmed : `${trimmed}Z`);
    return isNaN(parsed.getTime()) ? null : parsed;
}

